/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProjectsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProjectsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { trashProjectsDirectoryRoute } from '@jira/router-routes__trash-projects-directory-routes/src/trashProjectsDirectoryRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import TrashProjectsDirectory, {
	LazyTrashedProjectsAdmin,
} from './ui/admin-pages/trashed-projects/index.tsx';

export const trashProjectsDirectoryRouteEntry: Route = createEntry(
	trashProjectsDirectoryRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.trashed-projects',
		// eslint-disable-next-line no-restricted-syntax
		component: TrashProjectsDirectory,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProjectsSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],
		forPaint: [LazyAtlassianNavigation, LazyTrashedProjectsAdmin],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
